import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

interface DialogData {
  title: string;
  content: string;
  data: { [key: string]: any };
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  @Input() data!: DialogData;
  result: boolean | null = null;

  constructor(
    public bsModalRef: BsModalRef<ConfirmationDialogComponent>
  ) {}

  cancel(): void {
    this.result = false;
    this.bsModalRef.hide();
  }

  confirm(): void {
    this.result = true;
    this.bsModalRef.hide();
  }
}
